$(function () {
  var cartInfo;

  /* Helper methods */
  function pushEvent(event) {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push(event);
  }

  function fetchProduct(handle, callback) {
    $.get('/products/' + handle + '.json', callback);
  }

  function fetchCart(callback) {
    $.get('/cart.json', callback);
  }

  function buildCartEvent(product, id, action, quantity = 1) {
    return {
      event: DATA_LAYER_ACTIONS.ADD_TO_CART,
      ecommerce: {
        currencyCode: Shopify.currency.active,
        [action]: {
          products: [
            {
              name: product.title,
              id: id,
              price: product.variants[0].price,
              brand: 'MAM',
              category: product.product_type,
              quantity: quantity,
            },
          ],
        },
      },
    };
  }

  function mapLineItems(lineItems) {
    return lineItems.map(function (lineItem) {
      return {
        product_id: lineItem.product_id,
        product_name: lineItem.product_title,
        product_price: lineItem.price,
        product_category: lineItem.product_type,
      };
    });
  }

  /* End Helper methods */

  const DATA_LAYER_ACTIONS = {
    SUBSCRIBE: 'registro',
    PURCHASE: 'purchase',
    VIEW_CATEGORY: 'view-category',
    ADD_TO_CART: 'addToCart',
  };

  // User subscribes to news letter
  $('#SubscribeButton').click(function () {
    pushEvent({ event: DATA_LAYER_ACTIONS.SUBSCRIBE });
  });

  // User clicks on burguer menu category
  $('a.nav-el, nav-el a').click(function () {
    const selectedCategory = $(this)
      .closest('.mobile-nav__item:not(.nav-el)')
      .children()
      .first()
      .text();
    pushEvent({
      event: DATA_LAYER_ACTIONS.VIEW_CATEGORY,
      category: selectedCategory,
    });
  });

  /* User removes item from cart */
  $('.cart .btn-remove').click(function (event) {
    event.preventDefault();
    const link = $(this).attr('href');
    const removeInfo = link.split('?')[1].split('&');
    const quantity = +removeInfo[0].split('=')[1];
    const cartLine = removeInfo[0].split('=')[1] - 1;

    // If we don't have the cart info yet we don't register the event
    if (cartInfo) {
      let product = cartInfo.items[cartLine];
      product.variants = [{ price: product.price / 100 }];
      product.id = product.product_id;
       removeFromCartDataLayer(
        product,
        product.variant_id,
        quantity
      );
    }
    window.location.href = link;
  });

  function removeFromCartDataLayer(product, id, quantity) {
    pushEvent(buildCartEvent(product, id, 'remove', quantity));
  }

  /* End User removes item from cart */

  /* User adds item to cart */
  function addToCartDataLayer(data) {
    const variantId = new URL(window.location.href).searchParams.get('variant') ||  product.variants[0].id;
    const product = data.product;
    pushEvent(buildCartEvent(product, variantId, 'add'));
  }

  // fetch Cart
  fetchCart(function (ajaxCart) {
    cartInfo = ajaxCart;
  });

  // Override addItem function to wrap it
  if (addItem) {
    const addItemOg = addItem;
    addItem = function (productInfo) {
      const prodArrayInfo = productInfo.split(' ');
      fetchProduct(prodArrayInfo[1], addToCartDataLayer);
      addItemOg(prodArrayInfo[0]);
    };
  }
  /* End User adds item to cart */
});
